import theme from './theme';
const button = props => theme(props).button;
export const buttonPrimaryStyles = props => button(props).primary;
export const buttonSecondaryStyles = props => button(props).secondary;
export const buttonTertiaryStyles = props => button(props).tertiary;
export const buttonDestructiveStyles = props => button(props).destructive;
export const buttonSmallStyles = props => button(props).small;
export const buttonMediumStyles = props => button(props).medium;
export const buttonLargeStyles = props => button(props).large;